module.exports = __webpack_public_path__ + "static/media/bkash.d0222daf.png";